import http from "./httpService";
import config from "./../config.json";
import { getBase64 } from "../utils/stringUtils";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "contributions";

export const saveAccountContributionAsync = async (id, data) => {
  const files = [];

  if (typeof data.files !== "undefined")
    for (let i = 0; i < data.files.length; i++) {
      const file = await getBase64(data.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: data.files[i].name,
        content,
      });
    }

  const contribution = { ...data };
  contribution["contribution_type"] = data.contribution_type.value;
  contribution["files"] = files;

  return await http.post(`${apiEndpoint}/${id}`, contribution);
};

export const getAccountContributionsAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/${id}?q=${query}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getContributionTypes = () => {
  return [
    { value: 1, label: "SSS" },
    { value: 2, label: "Philhealth" },
    { value: 3, label: "Pag-IBIG" },
  ];
};

const contributionService = {
  saveAccountContributionAsync,
  getAccountContributionsAsync,
  getContributionTypes,
};

export default contributionService;
